
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { replace, concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Calendar_Warning from "../../public/assets/icons/Calendar_Warning.svg";
import { filter, isEmpty, empty as empty_1, toArray, exists, take, length, map, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { BlockHeader, TextValue } from "../Components/Text.js";
import { addDays, today, toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { useTranslation } from "react-i18next";
import { TextButton } from "../Components/Button.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapConsumableId, unwrapToolId } from "../Shared/Helper.js";
import { SetId__get_unwrap, ToolId__get_unwrap, ProblemReportId__get_unwrap } from "../Shared/Shared.js";
import { Helper_unitToTranslationKey } from "../Shared/Consumable.js";
import { unwrap, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { SWR_getSavedViews, SWR_getCategoryAvailability } from "../Requests/Availability.js";
import { toISOString } from "../Common.js";
import { Skeleton } from "../Components/Skeleton.js";
import { ColoredDot } from "../Components/ColoredDot.js";
import { OpenNotificationsCard } from "./OpenNotification.js";
import { getDashboardData } from "../Requests/Dashboard.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";

function DateWithIcon(props) {
    let elems_3;
    return reactElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
        let elems_2;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-2"])], (elems_2 = toList(delay(() => {
            let elems;
            return append(props.IsOverdue ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-4", "w-4", "self-center"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty(), delay(() => {
                let elems_1;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => ((!props.IsOverdue && props.HasOverdueInColumn) ? singleton("ml-6") : empty()))))], (elems_1 = [createElement(TextValue, {
                    FontWeight: "small",
                    TestId: "",
                    Text: toString(toLocalTime(props.Date), "dd.MM.yyyy"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            const matchValue = props.SecondRow;
            return (matchValue == null) ? singleton(defaultOf()) : singleton(matchValue);
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

function ProblemReportsCard(props) {
    let elems_5;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.problem_reports"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.description"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let problems;
                return append(map((problem) => {
                    let elems_3, elems_2;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_3 = [createElement(DateWithIcon, {
                        Date: problem.Date,
                        HasOverdueInColumn: false,
                        IsOverdue: false,
                        SecondRow: createElement(TextButton, {
                            ComponentState: "enabled",
                            Label: problem.SenderName,
                            OnClick: () => {
                                RouterModule_nav(ofArray(["receivers", problem.SenderId]), 1, 1);
                            },
                            TestId: "",
                            Variant: "blueButton",
                        }),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: problem.Description,
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: problem.ToolTitle,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["tools", unwrapToolId(problem.ToolId) + RouterModule_encodeQueryString(singleton_1(["problemReportId", ProblemReportId__get_unwrap(problem.ProblemReportId)]))]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: problem.ToolSubtitle,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["tools", unwrapToolId(problem.ToolId) + RouterModule_encodeQueryString(singleton_1(["problemReportId", ProblemReportId__get_unwrap(problem.ProblemReportId)]))]), 1, 1);
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                }, (problems = props.Problems, (length(problems) > 5) ? take(5, problems) : problems)), delay(() => {
                    let elems_4;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_4 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "problemreports"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function ReminderCard(props) {
    let elems_6;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_6 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("general.appointments"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.designation"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("dashboard.assigned_to"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let reminders;
                return append(map((reminder) => {
                    let elems_4, elems_2, elems_3;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_4 = [createElement(DateWithIcon, {
                        Date: reminder.Date,
                        HasOverdueInColumn: false,
                        IsOverdue: reminder.IsOverdue,
                        SecondRow: createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: reminder.Description,
                        }),
                    }), reactElement("div", createObj(singleton_1((elems_2 = toList(delay(() => {
                        const matchValue = reminder.CurrentAssignment;
                        if (matchValue == null) {
                            return singleton(defaultOf());
                        }
                        else {
                            const matchValue_1 = matchValue;
                            if (matchValue_1.tag === 0) {
                                return singleton(createElement(TextValue, {
                                    FontWeight: "small",
                                    TestId: "",
                                    Text: matchValue_1.fields[0],
                                }));
                            }
                            else {
                                const receiver = matchValue_1.fields[0];
                                return singleton(createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: receiver.ReceiverName,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["receivers", receiver.ReceiverId]), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "blueButton",
                                }));
                            }
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])))), reactElement("div", createObj(singleton_1((elems_3 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reminder.ToolTitle,
                        OnClick: () => {
                            const matchValue_2 = reminder.ReminderDateInfoType;
                            switch (matchValue_2.tag) {
                                case 0: {
                                    RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_2.fields[0])]), 1, 1);
                                    break;
                                }
                                case 1: {
                                    RouterModule_nav(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_2.fields[0])]), 1, 1);
                                    break;
                                }
                                case 2: {
                                    RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_2.fields[0])]), 1, 1);
                                    break;
                                }
                                default:
                                    RouterModule_nav(ofArray(["consumables", unwrapConsumableId(matchValue_2.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reminder.ToolSubtitle,
                        OnClick: () => {
                            const matchValue_3 = reminder.ReminderDateInfoType;
                            switch (matchValue_3.tag) {
                                case 0: {
                                    RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_3.fields[0])]), 1, 1);
                                    break;
                                }
                                case 1: {
                                    RouterModule_nav(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_3.fields[0])]), 1, 1);
                                    break;
                                }
                                case 2: {
                                    RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_3.fields[0])]), 1, 1);
                                    break;
                                }
                                default:
                                    RouterModule_nav(ofArray(["consumables", unwrapConsumableId(matchValue_3.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                }, (reminders = props.ReminderDates, (length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                    let elems_5;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_5 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "appointments"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function MinimumQuantityCard(props) {
    let elems_5;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.minimum_stock"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-5", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.stock"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.minimum_quantity"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.unit"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.storage"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let reminders;
                return append(map((reminder) => {
                    let elems_3, elems_2;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-5", "mt-2", "pb-2", "border-border", "border-b"])], (elems_3 = [createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: (reminder.tag === 1) ? reminder.fields[0].CurrentStock : ((reminder.tag === 2) ? reminder.fields[0].CurrentStock : reminder.fields[0].CurrentStock),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: (reminder.tag === 1) ? reminder.fields[0].MinimumQuantityStock : ((reminder.tag === 2) ? reminder.fields[0].MinimumQuantityStock : reminder.fields[0].MinimumQuantityStock),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: (reminder.tag === 1) ? t("unit.piece") : ((reminder.tag === 2) ? t("unit.piece") : t(Helper_unitToTranslationKey(reminder.fields[0].Unit))),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: (reminder.tag === 1) ? reminder.fields[0].StorageName : ((reminder.tag === 2) ? reminder.fields[0].StorageName : reminder.fields[0].StorageName),
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: (reminder.tag === 1) ? reminder.fields[0].DisplayName : ((reminder.tag === 2) ? reminder.fields[0].DisplayName : reminder.fields[0].DisplayName),
                        OnClick: () => {
                            switch (reminder.tag) {
                                case 1: {
                                    RouterModule_nav(ofArray(["toolswithquantity", unwrapToolId(reminder.fields[0].Id)]), 1, 1);
                                    break;
                                }
                                case 2: {
                                    const inventoryTranslation = t("general.tool");
                                    const setTranslation = t("general.set");
                                    RouterModule_nav(ofArray(["tools", concat("?isToolWithQuantity=", window.encodeURIComponent(concat(inventoryTranslation, ",", ...setTranslation)), "&label=", ...reminder.fields[0].DisplayName)]), 1, 1);
                                    break;
                                }
                                default:
                                    RouterModule_nav(ofArray(["consumables", unwrapConsumableId(reminder.fields[0].Id)]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                }, (reminders = props.MinimumQuantityReminders, (length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                    let elems_4;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_4 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "minimumstockquantity"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function PlannedReturnDateCard(props) {
    let elems_6;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_6 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.tool_return_date_title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.user"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let returnDates;
                return append(map((returnDate) => {
                    let elems_4, elems_2, elems_3;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_4 = [createElement(DateWithIcon, {
                        Date: returnDate.ReturnDate,
                        HasOverdueInColumn: exists((_arg) => _arg.IsOverdue, props.ToolReturnDates),
                        IsOverdue: returnDate.IsOverdue,
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: returnDate.ReceiverName,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["receivers", returnDate.ReceiverId]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])))), reactElement("div", createObj(singleton_1((elems_3 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: returnDate.Title,
                        OnClick: () => {
                            const matchValue = returnDate.Id;
                            if (matchValue.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: returnDate.Subtitle,
                        OnClick: () => {
                            const matchValue_1 = returnDate.Id;
                            if (matchValue_1.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                }, (returnDates = props.ToolReturnDates, (length(returnDates) > 5) ? take(5, returnDates) : returnDates)), delay(() => {
                    let elems_5;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_5 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "plannedreturndate"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function ReleaseDateCard(props) {
    let elems_5;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.release_dates"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.user"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let releaseDates;
                return append(map((releaseDate) => {
                    let elems_3, elems_2;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_3 = [createElement(DateWithIcon, {
                        Date: releaseDate.ReleaseDate,
                        HasOverdueInColumn: exists((_arg) => _arg.IsOverdue, props.ReleaseDates),
                        IsOverdue: releaseDate.IsOverdue,
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: releaseDate.ReceiverName,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["receivers", releaseDate.ReceiverId]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: releaseDate.Title,
                        OnClick: () => {
                            const matchValue = releaseDate.Id;
                            if (matchValue.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: releaseDate.Subtitle,
                        OnClick: () => {
                            const matchValue_1 = releaseDate.Id;
                            if (matchValue_1.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
                }, (releaseDates = props.ReleaseDates, (length(releaseDates) > 5) ? take(5, releaseDates) : releaseDates)), delay(() => {
                    let elems_4;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_4 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "releasedates"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function NextReservationCard(props) {
    let elems_4;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("dashboard.tool_next_reservations_title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-6", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.start_date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.end_date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.name"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.user"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.quantity"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let reservations;
                return append(map((reservation) => {
                    let elems_2;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-6", "mt-2", "pb-2", "border-border", "border-b"])], (elems_2 = [createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: toString(toLocalTime(reservation.StartDate), "dd.MM.yyyy"),
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: toString(toLocalTime(reservation.EndDate), "dd.MM.yyyy"),
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reservation.Name,
                        OnClick: () => {
                            let matchValue;
                            RouterModule_nav(ofArray(["reservations", (matchValue = reservation.GroupId, (matchValue == null) ? reservation.Id : matchValue)]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reservation.ReceiverInformation.ReceiverName,
                        OnClick: () => {
                            RouterModule_nav(ofArray(["receivers", reservation.ReceiverInformation.ReceiverId]), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: reservation.ToolInformation.Name,
                        OnClick: () => {
                            let matchValue_1;
                            RouterModule_nav(ofArray(toArray((matchValue_1 = reservation.ToolInformation.Type, (matchValue_1.tag === 1) ? ofArray(["toolswithquantity", reservation.ToolInformation.Id]) : ((matchValue_1.tag === 2) ? ofArray(["consumables", reservation.ToolInformation.Id]) : ((matchValue_1.tag === 3) ? ofArray(["sets", reservation.ToolInformation.Id]) : ((matchValue_1.tag === 4) ? ofArray(["reservations", defaultArg(reservation.GroupId, "")]) : ofArray(["tools", reservation.ToolInformation.Id]))))))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: defaultArg(reservation.ToolInformation.Quantity, ""),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
                }, (reservations = props.ReservationInfos, (length(reservations) > 5) ? take(5, reservations) : reservations)), delay(() => {
                    let elems_3;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_3 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "reservations"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function InMaintenanceCard(props) {
    let elems_6;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_6 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
            Text: t("general.in_maintenance"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_1 = [createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.date"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.tool"),
            }), createElement(TextValue, {
                FontWeight: "small",
                TestId: "",
                Text: t("general.user"),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let maintenanceInfos;
                return append(map((row) => {
                    let elems_4, elems_2, elems_3;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_4 = [createElement(TextValue, {
                        FontWeight: "small",
                        TestId: "",
                        Text: toString(toLocalTime(row.Date), "dd.MM.yyyy"),
                    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: row.Title,
                        OnClick: () => {
                            const matchValue = row.ToolInfoType;
                            if (matchValue.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "blueButton",
                    }), createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: row.Subtitle,
                        OnClick: () => {
                            const matchValue_1 = row.ToolInfoType;
                            if (matchValue_1.tag === 1) {
                                RouterModule_nav(ofArray(["sets", SetId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                            else {
                                RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(matchValue_1.fields[0])]), 1, 1);
                            }
                        },
                        TestId: "",
                        Variant: "default",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])))), reactElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
                        const matchValue_2 = row.CurrentAssignment;
                        if (matchValue_2 == null) {
                            return singleton(defaultOf());
                        }
                        else {
                            const matchValue_3 = matchValue_2;
                            if (matchValue_3.tag === 0) {
                                return singleton(createElement(TextValue, {
                                    FontWeight: "small",
                                    TestId: "",
                                    Text: matchValue_3.fields[0],
                                }));
                            }
                            else {
                                const receiver = matchValue_3.fields[0];
                                return singleton(createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: receiver.ReceiverName,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["receivers", receiver.ReceiverId]), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "blueButton",
                                }));
                            }
                        }
                    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
                }, (maintenanceInfos = props.InInMaintenanceInfos, (length(maintenanceInfos) > 5) ? take(5, maintenanceInfos) : maintenanceInfos)), delay(() => {
                    let elems_5;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_5 = [createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: t("dashboard.to_reports"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "in_maintenance"]))), 1, 1);
                        },
                        TestId: "",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function InspectionStatusCard(props) {
    let elems_13;
    const t = useTranslation()[0];
    const upcomingInspections = (props.InspectionStatus.UpcomingInspections == null) ? empty_1() : props.InspectionStatus.UpcomingInspections;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_13 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems = [createElement(BlockHeader, {
            Text: t("dashboard.inspection_status_title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))]))))), delay(() => {
            let elems_5, elems_1, elems_2, elems_3, elems_4;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-3", "mt-4"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#EFFEF4]", "rounded-lg", "p-4", "text-center"])], (elems_1 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#1E6939]", "mb-1"]),
                children: t("dashboard.inspection_status_ok"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#1E6939]"]),
                children: int32ToString(props.InspectionStatus.InspectedCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#FEFCE8]", "rounded-lg", "p-4", "text-center"])], (elems_2 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#854E0E]", "mb-1"]),
                children: t("dashboard.inspection_status_expired"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#854E0E]"]),
                children: int32ToString(props.InspectionStatus.ExpiredCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-light-red", "rounded-lg", "p-4", "text-center"])], (elems_3 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#981B1B]", "mb-1"]),
                children: t("dashboard.inspection_status_never_inspected"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#981B1B]"]),
                children: int32ToString(props.InspectionStatus.NeverInspectedCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-light-red", "rounded-lg", "p-4", "text-center"])], (elems_4 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#981B1B]", "mb-1"]),
                children: t("dashboard.inspection_status_failed"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#981B1B]"]),
                children: int32ToString(props.InspectionStatus.FailedCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                let elems_6;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-4"])], (elems_6 = [createElement(TextButton, {
                    ComponentState: "enabled",
                    Label: t("dashboard.to_reports"),
                    OnClick: () => {
                        RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "uninspectedtools"]))), 1, 1);
                    },
                    TestId: "",
                    Variant: "blueButton",
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                    let elems_7;
                    return !isEmpty(upcomingInspections) ? append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_7 = [createElement(BlockHeader, {
                        Text: t("dashboard.upcoming_inspections_title"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                        let elems_8;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mb-2", "border-border", "border-b-2"])], (elems_8 = [createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: t("general.designation"),
                        }), createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: t("dashboard.assigned_to"),
                        }), createElement(TextValue, {
                            FontWeight: "small",
                            TestId: "",
                            Text: t("general.tool"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                            let upcomingInspections_1;
                            return append(map((upcomingInspection) => {
                                let elems_11, elems_9, elems_10;
                                return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "mt-2", "pb-2", "border-border", "border-b"])], (elems_11 = [createElement(DateWithIcon, {
                                    Date: upcomingInspection.Date,
                                    HasOverdueInColumn: false,
                                    IsOverdue: upcomingInspection.IsOverdue,
                                    SecondRow: createElement(TextValue, {
                                        FontWeight: "small",
                                        TestId: "",
                                        Text: upcomingInspection.TemplateName,
                                    }),
                                }), reactElement("div", createObj(singleton_1((elems_9 = toList(delay(() => {
                                    const matchValue = upcomingInspection.CurrentAssignment;
                                    if (matchValue == null) {
                                        return singleton(defaultOf());
                                    }
                                    else {
                                        const matchValue_1 = matchValue;
                                        if (matchValue_1.tag === 0) {
                                            return singleton(createElement(TextValue, {
                                                FontWeight: "small",
                                                TestId: "",
                                                Text: matchValue_1.fields[0],
                                            }));
                                        }
                                        else {
                                            const receiver = matchValue_1.fields[0];
                                            return singleton(createElement(TextButton, {
                                                ComponentState: "enabled",
                                                Label: receiver.ReceiverName,
                                                OnClick: () => {
                                                    RouterModule_nav(ofArray(["receivers", receiver.ReceiverId]), 1, 1);
                                                },
                                                TestId: "",
                                                Variant: "blueButton",
                                            }));
                                        }
                                    }
                                })), ["children", reactApi.Children.toArray(Array.from(elems_9))])))), reactElement("div", createObj(singleton_1((elems_10 = [createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: upcomingInspection.ToolTitle,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(upcomingInspection.ToolId)]), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "blueButton",
                                }), createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: upcomingInspection.ToolSubtitle,
                                    OnClick: () => {
                                        RouterModule_nav(ofArray(["tools", ToolId__get_unwrap(upcomingInspection.ToolId)]), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "default",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_10))]))))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])));
                            }, (upcomingInspections_1 = upcomingInspections, (length(upcomingInspections_1) > 5) ? take(5, upcomingInspections_1) : upcomingInspections_1)), delay(() => {
                                let elems_12;
                                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "mt-2"])], (elems_12 = [createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: t("dashboard.to_reports"),
                                    OnClick: () => {
                                        RouterModule_nav(singleton_1("reports" + RouterModule_encodeQueryString(singleton_1(["report_id", "inspectioncalendar"]))), 1, 1);
                                    },
                                    TestId: "",
                                    Variant: "blueButton",
                                })], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))));
                            }));
                        }));
                    })) : empty();
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
}

function AvailabilityViewCounts(props) {
    let elems_3, elems_1, elems_2;
    const t = useTranslation()[0];
    const startDate = today();
    const endDate = addDays(today(), props.SavedView.PeriodDays - 1);
    const matchValue = SWR_getCategoryAvailability(props.SavedView.CategoryIds, toISOString(startDate), toISOString(endDate)).data;
    if (matchValue == null) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        const availability_1 = matchValue;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_3 = [reactElement("div", {
            className: join(" ", ["text-sm", "text-text-muted"]),
            children: replace(t("availability.period_next_days"), "{{days}}", int32ToString(props.SavedView.PeriodDays)) + (` (${toString(startDate, "dd.MM.yyyy")} – ${toString(endDate, "dd.MM.yyyy")})`),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-6"])], (elems_1 = map((tupledArg) => {
            let elems;
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2"])], (elems = [createElement(ColoredDot, {
                Color: tupledArg[0],
            }), reactElement("span", {
                className: join(" ", ["text-2xl", "font-semibold"]),
                children: int32ToString(tupledArg[1]),
            }), reactElement("span", {
                className: join(" ", ["text-sm"]),
                children: tupledArg[2],
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, ofArray([["green", availability_1.AvailableCount, t("availability.status_available")], ["orange", availability_1.PartiallyAvailableCount, t("availability.status_partially_available")], ["red", availability_1.UnavailableCount, t("availability.status_unavailable")]])), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_2 = [createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("dashboard.availability_details"),
            OnClick: () => {
                RouterModule_nav(singleton_1("availability" + RouterModule_encodeQueryString(singleton_1(["view", props.SavedView.Name]))), 1, 1);
            },
            TestId: "dashboard-availability-details-test-id",
            Variant: "blueButton",
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }
}

function AvailabilityCard(props) {
    let elems_3, elems, elems_2;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "p-8", "rounded"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(BlockHeader, {
        Text: patternInput[0]("dashboard.availability_title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-6"])], (elems_2 = map((savedView) => {
        let elems_1;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = [reactElement("div", {
            className: join(" ", ["font-bold"]),
            children: savedView.Name,
        }), createElement(AvailabilityViewCounts, {
            SavedView: savedView,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }, props.SavedViews), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function Dashboard(props) {
    let elems_4;
    const isOpenNotificationsVisible = !isEmpty(props.DashboardData.OpenNotifications);
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("grid"), delay(() => append(!isOpenNotificationsVisible ? append(singleton("grid-cols-1"), delay(() => singleton("2xl:grid-cols-[2fr_2fr]"))) : append(singleton("grid-cols-[2fr_1fr]"), delay(() => singleton("2xl:grid-cols-[2fr_2fr_1fr]"))), delay(() => append(singleton("gap-x-8"), delay(() => singleton("gap-y-4"))))))))))], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["col-start-1", "flex", "flex-col", "gap-4"])], (elems = toList(delay(() => {
            let matchValue;
            return append((matchValue = props.DashboardData.InspectionStatus, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement(InspectionStatusCard, {
                InspectionStatus: matchValue,
            }))), delay(() => append(singleton(createElement(ProblemReportsCard, {
                Problems: props.DashboardData.Problems,
            })), delay(() => append(singleton(createElement(InMaintenanceCard, {
                InInMaintenanceInfos: props.DashboardData.InMaintenanceToolsAndSets,
            })), delay(() => singleton(createElement(ReminderCard, {
                ReminderDates: props.DashboardData.ReminderDates,
            }))))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["col-start-1", "2xl:col-start-2", "flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
                let matchValue_1;
                return append((matchValue_1 = filter((_arg) => _arg.ShowOnDashboard, props.SavedAvailabilityViews), isEmpty(matchValue_1) ? singleton(defaultOf()) : singleton(createElement(AvailabilityCard, {
                    SavedViews: matchValue_1,
                }))), delay(() => append(singleton(createElement(PlannedReturnDateCard, {
                    ToolReturnDates: props.DashboardData.ToolReturnDates,
                })), delay(() => append(singleton(createElement(MinimumQuantityCard, {
                    MinimumQuantityReminders: props.DashboardData.MinimumQuantityReminder,
                })), delay(() => append(singleton(createElement(NextReservationCard, {
                    ReservationInfos: props.DashboardData.ReservationInfos,
                })), delay(() => {
                    let elems_1;
                    const matchValue_2 = props.DashboardData.ReleaseDates;
                    if (matchValue_2 == null) {
                        return singleton(defaultOf());
                    }
                    else {
                        const releaseDates = matchValue_2;
                        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["col-start-1", "2xl:col-start-2", "mb-4"])], (elems_1 = [createElement(ReleaseDateCard, {
                            ReleaseDates: releaseDates,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
                    }
                }))))))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_3;
                return isOpenNotificationsVisible ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["col-start-2", "2xl:col-start-3", "row-start-1"])], (elems_3 = [createElement(OpenNotificationsCard, {
                    Dispatch: props.Dispatch,
                    FormState: props.State.FormState,
                    NotificationToDelete: unwrap(props.State.NotificationToDelete),
                    OpenNotifications: props.DashboardData.OpenNotifications,
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : singleton(defaultOf());
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function DashboardView() {
    const dashboardData = getDashboardData();
    const savedAvailabilityViews = SWR_getSavedViews();
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, (msg, state) => update_1(dashboardData.mutate, msg, state), (_arg, _arg_1) => {
    }), undefined, []);
    if (dashboardData.error != null) {
        return createElement(Skeleton, {
            Variant: "normal",
        });
    }
    else {
        const matchValue = dashboardData.data;
        if (matchValue != null) {
            return createElement(Dashboard, {
                DashboardData: matchValue,
                Dispatch: patternInput[1],
                SavedAvailabilityViews: defaultArg(savedAvailabilityViews.data, empty_1()),
                State: patternInput[0],
            });
        }
        else {
            return createElement(Skeleton, {
                Variant: "normal",
            });
        }
    }
}

